import { render, staticRenderFns } from "./KnownMethodCards.vue?vue&type=template&id=53b99cf7&"
import script from "./KnownMethodCards.vue?vue&type=script&lang=js&"
export * from "./KnownMethodCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports